var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 165 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.113 16H117.775H46.0289H45.0001V17.0289V85.1742V87.5406H46.0289H117.775H120.142V85.1742V16H119.113ZM46.0289 85.1742V17.0289H117.775V85.1742H46.0289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.485 56.8136H116.912L106.486 45.6332L99.7645 38.3283L99.7302 38.3626L82.1023 19.5L78.6727 23.101V19.6372H68.7613V33.424L46.6407 56.5392H63.4455L63.3083 83.7699H75.2089V83.7356H78.6385V72.3838L81.5879 69.5372L96.7122 83.7356H111.288L100.485 73.344V56.8136ZM82.068 20.5289L99.1815 38.8427L94.4487 43.3354L82.0337 30.7147L78.6042 34.0756V24.0956L82.068 20.5289ZM69.4472 43.9527L77.9525 35.6532V49.0628H69.4472V43.9527ZM69.4472 43.0268V33.6984L77.9525 24.8158V34.7272L69.4472 43.0268ZM69.4472 20.3231H77.9525V23.8212L69.4472 32.7038V20.3231ZM48.2183 55.8533L68.7613 34.4186V43.6784L61.0791 51.1891H68.7613V83.084H63.9942L64.1314 55.8533H48.2183ZM68.7613 50.4689V50.5032H62.7253L68.7613 44.6387V49.783H78.6385V35.0359L82.068 31.7092L94.0029 43.8499L78.6385 58.4941V50.4689H68.7613ZM89.0643 62.3695L106.006 46.1477L115.335 56.1277H99.7988V72.6924L89.0643 62.3695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKLogo);
export default __webpack_public_path__ + "static/media/kLogo.93e89238e9fd4b0fa0b7a61e10a0f238.svg";
export { ForwardRef as ReactComponent };